<template>

    <section id="faq" class="faq">

      <div class="container">

        <div class="section-title mb-3" data-aos="fade-up">
          <div class="row">
            <h1 data-aos="fade-up">Perguntas frequentes</h1>
            <h5 class="mb-4" data-aos="fade-up" data-aos-delay="400">Surgiu alguma dúvida?</h5>
          </div>
        </div>

        <div class="faq-list">
          <ul>
            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-1" class="collapsed">
                Como funciona a abertura de empresa pela Sigame?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-1" class="collapse" data-bs-parent=".faq-list">
                <p>
                  <i class="bi bi-check-circle-fill" style="color: #009587;"></i>
                  No Sigame o início de qualquer negócio é com segurança e economia, e claro de forma fácil, e com os melhores especialistas.
                </p>
                <p>
                  Após contratar nosso serviço de Abertura de empresa, o cliente preenche seus dados, e as principais informações de seu negócio: endereço, atividades (CNAES) e sócios.
                </p>
                <p>
                  Depois de aprovada as características da PJ, enviamos para os órgãos públicos de registro analisar e autorizar abrir o CNPJ.
                </p>
                <p>
                  Emitimos a minuta do Contrato Social e enviamos ao cliente para validar, em seguida, realizamos os registros de forma digital, sem burocracia ou demanda de terceiros. Por fim, é só aguardar a finalização do processo de legalização e começar a faturar.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-2" class="collapsed">
                Quais são os documentos exigidos para abrir empresa?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-2" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Os documentos para abrir empresa podem variar bastante de acordo com a atividade a ser exercida e os órgãos governamentais envolvidos, mas no geral são:
                </p>
                <p>
                  <ul class="subitem">
                    <li>
                      RG e CPF
                    </li>
                  </ul>
                  <ul class="subitem">
                    <li>
                      Comprovante de endereço
                    </li>
                  </ul>
                  <ul class="subitem">
                    <li>
                      Se casado(a), certidão de casamento
                    </li>
                  </ul>
                  <ul class="subitem">
                    <li>
                      Cópia do IPTU ou documento que conste a inscrição imobiliária ou a indicação fiscal do imóvel onde a empresa será instalada
                    </li>
                  </ul>
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-3" class="collapsed">
                Preciso de contador para abrir empresa?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-3" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Sim, é preciso de contador para abrir empresa, a única exceção que não é obrigada por lei a ter um contador é o MEI.
                </p>
                <p>
                  Se você vai abrir uma microempresa ou qualquer outro porte de empresa que não é MEI, vai precisar da orientação de um contador, que será vinculado como responsável contábil pela sua empresa perante a Receita Federal e liberar o seu CNPJ.
                </p>
                <p>
                  Após a abertura você continuará precisando do serviço para cuidar e assinar sua contabilidade mensalmente.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-4" class="collapsed">
                O que é contabilidade online?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-4" class="collapse" data-bs-parent=".faq-list">
                <p>
                  A contabilidade online é a contabilidade feita com a ajuda da tecnologia.
                </p>
                <p>
                  Com praticidade e segurança você pode manter em dia todas as suas obrigações fiscais, contábeis e trabalhistas através da internet.
                </p>
                <p>
                  É uma forma acessível e simplificada de cuidar da rotina da empresa, sendo a melhor opção para quem não quer gastar muito tempo nem dinheiro com contabilidade.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-5" class="collapsed">
                Qual a diferença do Sigame para um Contador tradicional?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-5" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Somos um escritório de contabilidade registrado no CRC/PR e em todos os estados que prestamos serviços.
                </p>
                <p>
                  A diferença do nosso trabalho para uma contabilidade tradicional, é que desenvolvemos uma plataforma intuitiva, que oferece aos clientes todo serviço contábil e fiscal, que organiza e concentra todo o fluxo de informações automatizadas e documentos digitalizados enviados pelo cliente e pela Sigame.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-6" class="collapsed">
                Como funciona a processo de transferência de contabilidade com o antigo contador?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-6" class="collapse" data-bs-parent=".faq-list">
                <p>
                  O processo de transferência é bem simples!
                </p>
                <p>
                  Quando iniciar a contratação, você irá entrar em contato com seu antigo contador, informá-lo da desistência e acordar com o mesmo até quando ele realizará as transações e obrigações da sua empresa, para nos informar em seu cadastro, quando começamos.
                </p>
                <p>
                  Além disso, irá solicitar os dados e senhas pertinentes à empresa para inserir em nossa plataforma e dados de contato do antigo contador, para que possamos entrar em contato se necessário, para finalizar o processo de transferência da contabilidade.
                </p>
              </div>
            </li>

            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-7" class="collapsed">
                Qual a diferença do Sigame para um Contador tradicional?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-7" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Somos um escritório de contabilidade registrado no CRC/PR e em todos os estados que prestamos serviços.
                </p>
                <p>
                  A diferença do nosso trabalho para uma contabilidade tradicional, é que desenvolvemos uma plataforma intuitiva, que oferece aos clientes todo serviço contábil e fiscal, que organiza e concentra todo o fluxo de informações automatizadas e documentos digitalizados enviados pelo cliente e pelo Sigame.
                </p>
              </div>
            </li>

            <!--
            <li data-aos="fade-up" data-aos-delay="100">
              <a data-bs-toggle="collapse" data-bs-target="#faq-list-9" class="collapsed">
                Upgrade de plano de assinatura?
                <i class="bi bi-arrow-down-short icon-show"></i>
                <i class="bi bi-arrow-up-short icon-close"></i>
              </a>
              <div id="faq-list-9" class="collapse" data-bs-parent=".faq-list">
                <p>
                  Quando necessário, você poderá trocar o seu plano de assinatura contratado para ter acesso a uma franquia de notas maior para atender suas novas demandas.
                </p>
                <p class="mb-2">
                  Caso seu negócio ainda precisar de mais notas fiscais e não for um dos planos principais da plataforma, fale com a gente e solicite um plano personalizado para você.
                </p>
                <p>
                  <i class="bi bi-exclamation-circle-fill"></i>
                  Observação:
                  <ul class="subitem">
                    <li>
                      O upgrade de plano será considerado uma nova assinatura, na qual será cobrada a diferença entre o seu plano atual e o novo plano assinado. Nas faturas seguintes, será cobrado o valor normal do plano assinado mais os excedentes do plano anterior caso ele tenha sido ultrapassado naquele período.
                    </li>
                  </ul>
                </p>
              </div>
            </li>
            -->
          </ul>
        </div>

      </div>

  </section>

</template>

<script>
export default {
  name: 'FaqComp'
}
</script>

<style scoped lang="scss">
.faq {
  background-color: $faq-bg-color;
  padding: 20px 0;
  overflow: hidden;
  padding-bottom: 60px;
}

.faq .faq-list {
  padding: 0 100px;
}

.faq .faq-list ul {
  padding: 0;
  list-style: none;
}

.faq .faq-list li+li {
  margin-top: 15px;
}

.faq .faq-list li {
  padding: 20px;
  background: $bg-base;
  border-radius: 4px;
  position: relative;
}

.faq .faq-list a {
  display: block;
  position: relative;
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
  color: $color-base;
  outline: none;
  cursor: pointer;
  text-decoration: none;
}

.faq .faq-list .icon-help {
  font-size: 24px;
  position: absolute;
  right: 0;
  left: 20px;
  color: $a-color;
}

.faq .faq-list .subitem li {
  padding: 15px 0px 0px 0px;
  margin-top: 0px;
  margin-left: 40px;
  list-style: outside;
}

.faq .faq-list .icon-show,
.faq .faq-list .icon-close {
  font-size: 2rem;
  color: $a-color;
  position: absolute;
  right: 0;
  top: 0;
}

.faq .faq-list p {
  margin-bottom: 0;
  padding: 15px 0 0 0;
}

.faq .faq-list .icon-show {
  display: none;
}

.faq .faq-list a.collapsed {
  color: $color-base;
}

.faq .faq-list a.collapsed:hover {
  color: $a-color;
}

.faq .faq-list a.collapsed .icon-show {
  display: inline-block;
}

.faq .faq-list a.collapsed .icon-close {
  display: none;
}

@media (max-width: 1200px) {
  .faq .faq-list {
    padding: 0;
  }
  .faq .faq-list a {
    margin-right: 20px;
  }
  .faq .faq-list .icon-show,
  .faq .faq-list .icon-close {
    right: -28px;
  }
}

@media (max-width: 667px) {
  .faq .faq-list {
    padding: 0;
  }
  .faq .faq-list a {
    margin-right: 20px;
  }
  .faq .faq-list .icon-show,
  .faq .faq-list .icon-close {
    right: -28px;
  }
}

</style>
